module.exports = __webpack_public_path__ + "static/assets/332da45e1f5f4884df2d839b0ebce1ea.svg";